import { ItemList } from '../orm'
import { head, get, filter, lowerCase } from 'lodash'

class PhotographerList extends ItemList {
    getEntityKey() {
        return "customer/photographer"
    }
  
    loadAllPhotographers() {
      return async (dispatch, getState) => {
        dispatch(this.updatePaginationNumItemsPerPage(1000))
        dispatch(this.fetchListIfNeeded())
      }
    }

    getAllPhotographers() {
      return this.getVisibleObjects()
    }

    getPhotographerForId(photographer_id) {
      return this.getObject(photographer_id)
    }

    getPhotographerIdForNickname(photographer_nickname) {
      const photographer =  head(filter(this.getAllPhotographers(), (photographer) => lowerCase(get(photographer, "last_name")) === lowerCase(photographer_nickname)))
      return get(photographer, "id") 
    }

}

export const photographerList = new PhotographerList("photographer_default")


